<template>
  <div class="method-picker-panel">
    <div class="method-picker-panel__stage">
      <header class="method-picker-panel__header">
        <span class="method-picker-panel__count">{{ selectionCount }}</span>
        <span class="method-picker-panel__headerText">项资源已选</span>
        <span class="method-picker-panel__headerSep" aria-hidden="true">·</span>
        <span class="method-picker-panel__headerHint">请选择打标方式</span>
      </header>

      <div class="method-picker-panel__cards">
        <button
          v-for="item in methodOptions"
          :key="item.value"
          type="button"
          class="method-picker-panel__card"
          :class="{ 'method-picker-panel__card--active': value === item.value }"
          @click="handleSelect(item.value)"
        >
          <span
            class="method-picker-panel__iconWrap"
            :class="`method-picker-panel__iconWrap--${item.value}`"
          >
            <i :class="item.icon" aria-hidden="true" />
          </span>
          <span class="method-picker-panel__cardTitle">{{ item.title }}</span>
          <span class="method-picker-panel__cardDesc">{{ item.desc }}</span>
          <span class="method-picker-panel__cardHint">{{ item.hint }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { METHOD_PICKER_OPTIONS } from './helpCopy'

export default {
  name: 'MethodPickerPanel',
  props: {
    value: {
      type: String,
      default: '',
    },
    selectionCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      methodOptions: METHOD_PICKER_OPTIONS,
    }
  },
  methods: {
    handleSelect(method) {
      this.$emit('input', method)
      this.$emit('select', method)
    },
  },
}
</script>

<style scoped>
/** 右侧内容区内居中展示方式卡片，不挤占左栏 */
.method-picker-panel {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 4px 28px;
  box-sizing: border-box;
}

.method-picker-panel__stage {
  width: 100%;
  max-width: 680px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 28px;
}

.method-picker-panel__header {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  font-family: var(--link-font-family);
  line-height: 1.4;
}

.method-picker-panel__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--link-surface-head, #f3f0ea);
  border: 1px solid var(--link-line-strong, #e5dfd6);
  font-size: var(--link-text-md);
  font-weight: var(--link-font-semibold);
  font-variant-numeric: tabular-nums;
  color: var(--link-ink-emphasis);
}

.method-picker-panel__headerText {
  font-size: var(--link-text-lg);
  font-weight: var(--link-font-semibold);
  color: var(--link-ink);
}

.method-picker-panel__headerSep {
  color: var(--link-ink-faint);
  font-weight: var(--link-font-regular);
}

.method-picker-panel__headerHint {
  font-size: var(--link-text-md);
  font-weight: var(--link-font-regular);
  color: var(--link-ink-muted);
}

.method-picker-panel__cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.method-picker-panel__card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-height: 168px;
  padding: 22px 20px 18px;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 14px;
  background: var(--link-card-surface, #f7f4ef);
  text-align: left;
  cursor: pointer;
  box-shadow: var(--link-highlight-top), var(--link-shadow-card);
  transition:
    border-color 0.22s ease,
    box-shadow var(--link-dur) var(--link-ease),
    background 0.22s ease;
}

.method-picker-panel__card:hover {
  border-color: var(--link-ink-faint);
  background: var(--link-surface-row, #faf8f5);
  box-shadow: var(--link-highlight-top), var(--link-shadow-card-hover);
}

.method-picker-panel__card--active {
  border-color: var(--link-ink-muted);
  background: var(--link-surface-row, #faf8f5);
  box-shadow:
    0 0 0 1px rgba(68, 64, 60, 0.08),
    0 8px 24px rgba(28, 25, 23, 0.05);
}

.method-picker-panel__iconWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  font-size: var(--link-icon-md);
}

.method-picker-panel__iconWrap--page {
  background: var(--link-surface-head, #f3f0ea);
  color: var(--link-ink-emphasis);
}

.method-picker-panel__iconWrap--excel {
  background: var(--link-btn-create-bg);
  color: var(--link-status-success-ink);
}

.method-picker-panel__cardTitle {
  font-size: var(--link-text-lg);
  font-weight: var(--link-font-semibold);
  color: var(--link-ink);
  letter-spacing: -0.01em;
}

.method-picker-panel__cardDesc {
  font-size: var(--link-text-md);
  line-height: 1.6;
  color: var(--link-ink-secondary);
}

.method-picker-panel__cardHint {
  margin-top: auto;
  padding-top: 2px;
  font-size: var(--link-text-xs);
  color: var(--link-ink-muted);
}
</style>
